(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.slick) {
            const splitSlider = $('.avency-split-slider');

            $('.avency-split-slider__auto-size .avency-split-sliderItem').css('height', ($(window).height() - ($(window).height() * 0.15)));
            window.addEventListener('resize', function() {
                $('.avency-split-slider__auto-size .avency-split-sliderItem').css('height', ($(window).height() - ($(window).height() * 0.15)));
            });

            $(splitSlider).on('init', function () {
                $('.avency-split-sliderItem').find('.container').fadeIn(800);
            });
            $(splitSlider).slick();
            $(splitSlider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                const splitSliderItem = $('.avency-split-sliderItem');
                $(splitSliderItem).eq(currentSlide).find('.container').fadeOut(500);
                $(splitSliderItem).eq(nextSlide).find('.container').fadeIn(6000);
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
